import { Injectable } from '@angular/core';
import { PlessHttp } from 'src/app/shared/http/pless-http.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessDialogServiceSub } from 'src/app/commons/kymw00/pless-dialog-service-sub';
import { KYMW7002Model } from '../kymw7002.model';

import type { GetApprovalFlowTypeInfoCondition } from '../vo/get-approval-flow-type-info-condition.model';

// リクエスト構造
export interface GetApprovalFlowTypeInfoRequest {
  search: {
    ApprovalFlowTypeInfo: {
      condition: GetApprovalFlowTypeInfoCondition;
    };
  };
}

// レスポンス構造
export interface GetApprovalFlowTypeInfoResponse {
  /** 承認フロー区分 */
  ApprovalFlowType: string;
}

/**
 * 承認フロー区分情報 取得サービス
 * @export GetApprovalFlowTypeInfoService
 * @class GetApprovalFlowTypeInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetApprovalFlowTypeInfoService extends PlessJsonResponderSub<GetApprovalFlowTypeInfoResponse> {
  model: KYMW7002Model;
  private requestData: GetApprovalFlowTypeInfoRequest;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetApprovalFlowTypeInfoService
   */
  private getBody(): PlessRequest {
    // 検索条件を設定
    const condition: GetApprovalFlowTypeInfoCondition = {
      OrderCode: this.model.orderCode,
      MediumType: this.model.mediumType,
      FeatureCode: this.model.featureCode,
    };

    // リクエストを設定
    this.requestData = {
      search: {
        ApprovalFlowTypeInfo: { condition }
      }
    };

    return new PlessRequest(this.requestData);
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetApprovalFlowTypeInfoService
   */
  execute(model: KYMW7002Model, f?: () => void): void {
    this.model = model;
    if (f) this.calbak = f;
    this.send('getApprovalFlowTypeInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetApprovalFlowTypeInfoService
   */
  success(data: GetApprovalFlowTypeInfoResponse) {
    this.model.approvalFlowType = data.ApprovalFlowType;

    if (this.calbak) this.calbak();
  }

}
